export const CustomerDiscountTypes = {
  FIXED_PER_MAP_PART: "fixedPerMapPart",
  PERCENTAGE: "percentage",
  MANUAL_TOTAL: "manualTotal",
};

const numberOrZero = (value) => {
  const numberValue = Number(value);
  return Number.isFinite(numberValue) && numberValue > 0 ? numberValue : 0;
};

const clampDiscount = (discount, subtotal) => Math.min(Math.max(discount, 0), subtotal);

export const calculateCustomerPrice = ({ pricePerMapPart, mapParts, discountEnabled, discountType, discountValue }) => {
  const safePricePerMapPart = numberOrZero(pricePerMapPart);
  const safeMapParts = Math.max(0, Math.floor(numberOrZero(mapParts)));
  const safeDiscountValue = numberOrZero(discountValue);
  const subtotal = safePricePerMapPart * safeMapParts;

  let discountTotal = 0;
  if (discountEnabled) {
    switch (discountType) {
      case CustomerDiscountTypes.FIXED_PER_MAP_PART:
        discountTotal = safeDiscountValue * safeMapParts;
        break;
      case CustomerDiscountTypes.PERCENTAGE:
        discountTotal = subtotal * (safeDiscountValue / 100);
        break;
      case CustomerDiscountTypes.MANUAL_TOTAL:
        discountTotal = safeDiscountValue;
        break;
      default:
        discountTotal = 0;
    }
  }

  const clampedDiscountTotal = clampDiscount(discountTotal, subtotal);
  return {
    pricePerMapPart: safePricePerMapPart,
    mapParts: safeMapParts,
    subtotal,
    discountTotal: clampedDiscountTotal,
    finalTotal: subtotal - clampedDiscountTotal,
  };
};
